import { FC } from "react";

import { ChatChartProps } from "./types";

export const MultiseriesLineChart: FC<ChatChartProps> = ({ chartData }) => {
  console.info(chartData);

  return null;
};
